/** Toggle browser fullscreen for the whole document (standard + webkit + moz). */
export function toggleAppFullscreen(): void {
  const doc = document as Document & {
    webkitFullscreenElement?: Element | null;
    webkitExitFullscreen?: () => void;
    mozCancelFullScreen?: () => void;
  };
  const root = document.documentElement as HTMLElement & {
    webkitRequestFullscreen?: () => void;
    mozRequestFullScreen?: () => void;
  };
  const isFs =
    document.fullscreenElement ??
    doc.webkitFullscreenElement ??
    (document as Document & { mozFullScreenElement?: Element | null })
      .mozFullScreenElement;

  if (isFs) {
    if (document.exitFullscreen) {
      void document.exitFullscreen().catch(() => {});
    } else if (doc.webkitExitFullscreen) {
      void doc.webkitExitFullscreen();
    } else if (doc.mozCancelFullScreen) {
      doc.mozCancelFullScreen();
    }
  } else {
    if (root.requestFullscreen) {
      void root.requestFullscreen().catch(() => {});
    } else if (root.webkitRequestFullscreen) {
      try {
        root.webkitRequestFullscreen();
      } catch {
        /* ignore */
      }
    } else if (root.mozRequestFullScreen) {
      void root.mozRequestFullScreen();
    }
  }
}
